export const SET_PROJECTS_FOLDER_MOVE_DIALOG_IS_OPEN = 'SET_PROJECTS_FOLDER_MOVE_DIALOG_IS_OPEN'
export const SET_PROJECTS_FOLDER_MOVE_PENDING = 'SET_PROJECTS_FOLDER_MOVE_PENDING'
export const SET_PROJECTS_FOLDER_TO_MOVE = 'SET_PROJECTS_FOLDER_TO_MOVE'
